import FileUploadModal from "./FileUploadModal";

export default FileUploadModal
